import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";

function ReportModal() {
  const { t } = useContext(LanguageContext);

  return (
    <div id="modalReport" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="modalReportTitle" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h3 className="modal-title" id="modalReportTitle">{t("What is the reason for reporting this site?")}</h3>
        </div>
        <div className="modal-body">


          <div className="form-check mb-3">
            <input type="radio" id="formRadio1" className="form-check-input" name="report"/>
            <label className="form-check-label" htmlFor="formRadio1">{t("The domain is inactive or parked")}</label>
          </div>
          <div className="form-check mb-3">
            <input type="radio" id="formRadio2" className="form-check-input" name="report"/>
            <label className="form-check-label" htmlFor="formRadio2">{t("The domain redirects to another domain")}</label>
          </div>
          <div className="form-check mb-3">
            <input type="radio" id="formRadio3" className="form-check-input" name="report"/>
            <label className="form-check-label" htmlFor="formRadio3">{t("The site contains inappropriate content")}</label>
          </div>
          <div className="form-check mb-3">
            <input type="radio" id="formRadio4" className="form-check-input" name="report"/>
            <label className="form-check-label" htmlFor="formRadio4">{t("The site is incorrectly categorized")}</label>
          </div>
          <div className="form-check mb-3">
            <input type="radio" id="formRadio5" className="form-check-input" name="report"/>
            <label className="form-check-label" htmlFor="formRadio5">{t("Other")}</label>
          </div>
          <div className="mb-3">
            <textarea className="form-control" placeholder={t("Please specify why you would like to report this site")} rows="4"></textarea>
          </div>



        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-white" data-bs-dismiss="modal">{t("Close")}</button>
          <button type="button" className="btn btn-primary">{t("Send Report")}</button>
        </div>
      </div>
    </div>
  </div>
  );
}

export default ReportModal;
